export default {
  A: `
    [6,8]
       +
      + +
     +   +
     +   +
     +++++
     +   +
     +   +
  `,
  B: `
    [6,8]
     ++++
     +   +
     +   +
     ++++
     +   +
     +   +
     ++++
  `,
  C: `
    [6,8]
      +++
     +   +
     +
     +
     +
     +   +
      +++
  `,
  D: `
    [6,8]
     +++
     +  +
     +   +
     +   +
     +   +
     +  +
     +++
  `,
  E: `
    [6,8]
     +++++
     +
     +
     ++++
     +
     +
     +++++
  `,
  F: `
    [6,8]
     +++++
     +
     +
     ++++
     +
     +
     +
  `,
  G: `
    [6,8]
      +++
     +   +
     +
     +  ++
     +   +
     +  ++
      ++ +
  `,

  H: `
    [6,8]
     +   +
     +   +
     +   +
     +++++
     +   +
     +   +
     +   +
  `,
  I: `
    [6,8]
      +++
       +
       +
       +
       +
       +
      +++
  `,
  J: `
    [6,8]
      +++
       +
       +
       +
       +
     + +
      +
  `,
  K: `
    [6,8]
     +   +
     +  +
     + +
     ++
     + +
     +  +
     +   +
  `,
  L: `
    [6,8]
      +
      +
      +
      +
      +
      +
      ++++
  `,
  M: `
    [6,8]
     +   +
     ++ ++
     + + +
     + + +
     +   +
     +   +
     +   +
  `,
  N: `
    [6,8]
     +   +
     ++  +
     + + +
     +  ++
     +   +
     +   +
     +   +
  `,

  O: `
    [6,8]
      +++
     +   +
     +   +
     +   +
     +   +
     +   +
      +++
  `,
  P: `
    [6,8]
     +++
     +  +
     +   +
     +  +
     +++
     +
     +
  `,
  Q: `
    [6,8]
     +   +
     ++  +
     + + +
     +  ++
     +   +
     +   +
     +   +
  `,
  R: `
    [6,8]
     ++++
     +   +
     +   +
     +  +
     +++
     +  +
     +   +
  `,
  S: `
    [6,8]
      +++
     +   +
      +
       +
        +
     +   +
      +++
  `,
  T: `
    [6,8]
     +++++
       +
       +
       +
       +
       +
       +
  `,

  U: `
    [6,8]
     +   +
     +   +
     +   +
     +   +
     +   +
     +  ++
      ++ +
  `,
  V: `
    [6,8]
     +   +
     +   +
     +   +
     +   +
     +   +
      + +
       +
  `,
  W: `
    [6,8]
     +   +
     +   +
     +   +
     + + +
     + + +
     + + +
      + +
  `,
  X: `
    [6,8]
     +   +
     +   +
      + +
       +
      + +
     +   +
     +   +
  `,
  Y: `
    [6,8]
     +   +
     +   +
      + +
       +
       +
       +
       +
  `,
  Z: `
    [6,8]
     +++++
         +
      + +
       +
      + +
     +
     +++++
  `,
}



// WEBPACK FOOTER //
// ./src/dot-fonts/letters.js